// extracted by mini-css-extract-plugin
export default {"compactView":"CompactView_compactView__0S2HC","isDisabledCompactView":"CompactView_isDisabledCompactView__dwL6j"};